import { getRequestConfig, withMakeRequest } from '~/api';
import Request from '~/api/Request.ts';

type GetPylonEmailHashResponse = {
  supportHash: string;
};

const getPylonEmailHash: () => Promise<string> = withMakeRequest(
  async () =>
    await Request.getInstance().get(
      `/users/support-hash`,
      getRequestConfig({ addEnvDomain: true })
    ),
  (data: GetPylonEmailHashResponse) => data.supportHash
);

export { getPylonEmailHash };
